import { DateOnly } from '@if/core/date'
import { useMemo } from 'react'
import { getEditPaymentSchema } from '../EditPayments-schema'

/**
 * One added payment validates against the same schema as a row of the editor's table, so a
 * payment cannot be staged in a shape the table would then refuse.
 */
export const useAddPaymentSchema = (loanActivationDate: DateOnly, canBypassAcpLock = false) =>
  useMemo(() => getEditPaymentSchema(loanActivationDate, canBypassAcpLock), [loanActivationDate, canBypassAcpLock])
